import { useState, useEffect } from "react";
import { StyleSheet, View } from "react-native";
import { CustomAlert } from "@/components/ThemedAlert";
import { ThemedText } from "@/components/ThemedText";
import ThemedScreen from "@/components/ThemedScreen";
import { ThemedButton } from "@/components/ThemedButton";
import { router } from "expo-router";
import { flushQueue, getQueueLength } from "@/services/batch-logger";
import { useThemeColor } from "@/hooks/useThemeColor";

export default function TestScreen() {
  const [queueLength, setQueueLength] = useState(0);
  const [isFlushing, setIsFlushing] = useState(false);

  const cardBgColor = useThemeColor({}, "card");
  const borderColor = useThemeColor({}, "border");

  useEffect(() => {
    setQueueLength(getQueueLength());
  }, []);

  const handleAddTestLog = () => {
    console.log("Developer manual test log created at: " + new Date().toLocaleTimeString());
    setQueueLength(getQueueLength());
  };

  const handleFlushCache = async () => {
    setIsFlushing(true);
    try {
      const result = await flushQueue();
      setQueueLength(getQueueLength());
      if (result.success) {
        CustomAlert.alert("Logs Flushed", `Successfully flushed ${result.count} logs to the backend.`);
      } else {
        CustomAlert.alert("Flush Failed", result.error?.message || "Failed to flush log cache.");
      }
    } catch (error: any) {
      CustomAlert.alert("Error", error.message || "An unexpected error occurred.");
    } finally {
      setIsFlushing(false);
    }
  };

  return (
    <ThemedScreen
      title="Test"
      leftIcon={{
        name: "arrow-back",
        onPress: () => router.navigate("/(tabs)/admin" as any),
      }}
      rightIcon={{
        name: "search",
        onPress: () => CustomAlert.alert("Handle search here..."),
      }}
    >
      <View style={styles.container}>
        <ThemedText type="subtitle" style={{ marginBottom: 16 }}>
          Test Dashboard
        </ThemedText>
        <ThemedButton title="Test Alert System" onPress={() => router.push("/admin/test/test-alert")} style={{ marginBottom: 12 }} />

        <ThemedButton title="Test Logging system" onPress={() => console.error(new Error("Developer manual test error"))} style={{ marginBottom: 12 }} />

        <ThemedButton title="Test Media Storage" onPress={() => router.push("/admin/test/test-media")} style={{ marginBottom: 12 }} />

        <ThemedButton title="Test Auth State" onPress={() => router.push("/admin/test/test-auth")} style={{ marginBottom: 12 }} />

        <View style={[styles.card, { backgroundColor: cardBgColor, borderColor: borderColor }]}>
          <ThemedText type="defaultSemiBold" style={{ marginBottom: 8 }}>
            Logging Diagnostics
          </ThemedText>
          <ThemedText style={{ marginBottom: 16, opacity: 0.7 }}>
            Buffered Log Cache Size: <ThemedText type="defaultSemiBold">{queueLength}</ThemedText> logs
          </ThemedText>
          <View style={styles.buttonRow}>
            <ThemedButton
              title="Add Test Log"
              variant="secondary"
              onPress={handleAddTestLog}
              style={{ flex: 1, marginRight: 8 }}
            />
            <ThemedButton
              title="Flush Log Cache"
              variant="primary"
              onPress={handleFlushCache}
              disabled={isFlushing}
              style={{ flex: 1 }}
            />
          </View>
        </View>
      </View>
    </ThemedScreen>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
  },
  headerImage: {
    color: "#808080",
    bottom: -90,
    left: -35,
    position: "absolute",
  },
  titleContainer: {
    flexDirection: "row",
    gap: 8,
  },
  card: {
    padding: 16,
    borderRadius: 14,
    borderWidth: 1,
    marginTop: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  buttonRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
